"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var colors_1 = require("../util/colors");
var grid_1 = require("./grid");
var IconButton_1 = __importDefault(require("./IconButton"));
var spacing_1 = require("./spacing");
var typography_1 = require("./typography");
var FullPage = function (_a) {
    var goBack = _a.goBack, headerCenterContent = _a.headerCenterContent, headerRightContent = _a.headerRightContent, children = _a.children, footer = _a.footer, _b = _a.pad, pad = _b === void 0 ? true : _b;
    var Wrapper = pad ? grid_1.LayoutWrapper : spacing_1.Div;
    (0, react_1.useEffect)(function () {
        window.scrollTo({ top: 0 });
    }, []);
    return (react_1.default.createElement(grid_1.Container, { style: { minHeight: '100vh' }, direction: "column" },
        react_1.default.createElement(spacing_1.Div, { bb: true, style: {
                position: 'sticky',
                top: 0,
                backgroundColor: colors_1.colors.white,
                zIndex: 10,
            } },
            react_1.default.createElement(grid_1.Container, { px: 2, align: "center", justify: "space-between", wrap: false, style: { height: '4rem' } },
                react_1.default.createElement(grid_1.Container, { align: "center", justify: "flex-start", style: { width: '25%' } }, goBack && (react_1.default.createElement(grid_1.Container, { wrap: false, center: true, style: { cursor: 'pointer' }, onClick: goBack },
                    react_1.default.createElement(IconButton_1.default, { icon: "back", name: "back" }),
                    react_1.default.createElement(typography_1.P, { pl: 1 }, "Back")))),
                headerCenterContent || react_1.default.createElement("div", null),
                react_1.default.createElement(grid_1.Container, { justify: "flex-end", style: { width: '25%' } }, headerRightContent))),
        react_1.default.createElement(Wrapper, null, children),
        footer && react_1.default.createElement("div", { style: { marginTop: 'auto' } }, footer)));
};
exports.default = FullPage;
//# sourceMappingURL=FullPage.js.map